import content from '../content.json';
import { getQuestionandAnswersetsFromJson } from './helpers';

export const questionAndAnswerSets = getQuestionandAnswersetsFromJson(content);
